module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_7005.cd4b99a1.png";